import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { LifecycleStageEntity } from '../../Risks/models/Risk';

const actionConfig = { resourcePath: '/risks/lifecycle-stages' };

export const riskLifecycleStagesActions = createRestActions<LifecycleStageEntity>(actionConfig);

export const RiskLifecycleStagesStore = createRestStore<LifecycleStageEntity>({
  name: 'risk-lifecycle-stages-store',
  actions: riskLifecycleStagesActions,
  actionConfig,
  containerDisplayName: 'risk-lifecycle-stages-container',
  onInitAction: null,
});

export const useRiskLifecycleStagesData = createDataHook(RiskLifecycleStagesStore);
export const useRiskLifecycleStagesIsLoading = createLoadingHook(RiskLifecycleStagesStore);
export const useRiskLifecycleStagesActions = createActionsHook(RiskLifecycleStagesStore);
export const didRiskLifecycleStagesMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
